<template>
  <div class="tags-page">
    <div class="container">
      <div v-if="studyId" class="tags-page__header d-flex">
        <template v-if="this.$route.name == 'data-capture-form-activity-review'">
          <router-link :to="{ name: 'forms-list' }" class="d-block tags-page__back-to-activities fs-14">Data Capture Forms&nbsp;</router-link>
          <span>/&nbsp;</span>
          <router-link data-testid="page-title"
            class="d-block tags-page__back-to-activities fs-14"
            :to="{
              name: 'data-capture-form-activity-details',
              params: {
                studyId: studyId,
                activityId: activityId,
                mode: activityMode,
                revisionId: isPublished ? (revisionId ? revisionId : activityId) : ''
              },
              query: { revisionId: revisionId, mode: activityMode }
            }"
          >
            Activity Information&nbsp;</router-link
          >
        </template>
        <template v-else>
          <router-link
            :to="{
              name: 'study-activities',
              params: { studyId, mode: activityMode }
            }"
            class="d-block tags-page__back-to-activities fs-14"
            >Activities&nbsp;</router-link
          >
          <span>/&nbsp;</span>
          <router-link
            class="d-block tags-page__back-to-activities fs-14"
            :to="{
              name: 'activity-details',
              params: {
                activityId,
                studyId,
                mode: activityMode,
                revisionId: isPublished ? (revisionId ? revisionId : activityId) : ''
              },
              query: { revisionId: revisionId, mode: activityMode }
            }"
            >Activity Information&nbsp;</router-link
          >
        </template>
        <span>/ Create Activity</span>
      </div>
      <div v-else class="tags-page__header d-flex">
        <router-link :to="{ name: 'activity-library-homepage' }" class="d-block tags-page__back-to-activities fs-14">Activity Library&nbsp;</router-link>
        <span>/ Activity Configurator</span>
      </div>

      <div class="col-lg-12 p-0">
        <div class="mt-30 container-style mb-30">
          <div class="p-30">
            <div class="row">
              <div class="fw-bold fs-20 color_666669">
                Please review your activity
              </div>
              <div class="warning-message">
                <span><img alt="warning" src="static/img/activity-configurator/warn.png" class="warn-icon pr-5"/></span>Please note that for any activity steps that request and/or collect PII - the data responses cannot be tokenized and will be available in your data export as provided.
              </div>
              <div class="survey_details_section pt-15">
                <div class="row pb-10">
                  <div class="col-lg-10 fw-500 fs-16 p-0 color_959fa4">
                    Activity Information
                  </div>
                  <div class="text-right color_grey">
                    <div v-if="studyId">
                      <button v-if="this.$route.name == 'data-capture-form-activity-review'" class="btn btn-default color_blue br-2 edit_button" v-on:click="changeRoute('data-capture-form-activity-details')">
                        Edit
                      </button>
                      <button v-else class="btn btn-default color_blue br-2 edit_button" v-on:click="changeRoute('study-activities-activity-details')">
                        Edit
                      </button>
                    </div>
                    <button v-else class="btn btn-default color_blue br-2 edit_button" v-on:click="changeRoute('activity-details')">
                      Edit
                    </button>
                  </div>
                </div>
                <div data-testid="activityInfo" class="row">
                  <div class="act_info_box col-md-3 p-0">
                    <div class="survey_heading">Title</div>
                    <div class="survey_content mb-17">
                      {{ activityData.name ? activityData.name : "N/A" }}
                    </div>
                    <div class="survey_heading">
                      Abbreviation
                    </div>
                    <div class="survey_content mb-17">
                      {{ activityData.abbreviation ? activityData.abbreviation : "N/A" }}
                    </div>
                    <div id="customTherapeuticArea" class="survey_heading">Therapeutic area</div>
                    <div class="survey_content mb-17 therapeutic" v-if="activityData.customTherapeuticArea">
                      {{ activityData.customTherapeuticArea ? activityData.customTherapeuticArea : "N/A" }}
                    </div>
                    <div id="therapeuticArea" class="survey_content mb-17" v-else>
                      {{ activityData.therapeuticArea ? activityData.therapeuticArea : "N/A" }}
                    </div>
                    <div class="survey_heading">Therapeutic indication</div>
                    <div class="survey_content mb-17">
                      {{ activityData.therapeuticIndication ? activityData.therapeuticIndication : "N/A" }}
                    </div>
                    <div class="survey_heading">Permissions</div>
                    <div class="survey_content mb-17">
                      <div class="mb-5" v-if="activityData.completedBy">Completed By: {{ activityData.completedBy.join(", ") }}</div>
                      <div v-if="activityData.canViewBy">Can View: {{ activityData.canViewBy.join(", ") }}</div>
                    </div>
                    <div class="survey_heading" v-if="activityData.hasOwnProperty('customFooter')">
                      Custom Footer
                    </div>
                    <div class="survey_content" v-if="activityData.hasOwnProperty('customFooter')" v-html="activityData.customFooter"></div>
                  </div>
                  <div class="author_info_box col-md-3 p-0">
                    <div class="survey_heading">Author</div>
                    <div class="survey_content mb-17">
                      {{ activityData.author ? activityData.author : "N/A" }}
                    </div>
                    <div class="survey_heading">Copyright</div>
                    <div class="survey_content mb-17">
                      {{ activityData.copyright ? activityData.copyright : "N/A" }}
                    </div>
                    <div class="survey_heading">Available Languages</div>
                    <div class="survey_content mb-17">
                      {{ languages }}
                    </div>
                    <div class="survey_heading">Groups</div>
                    <div class="survey_content mb-17">
                      {{ activityData.groupName ? activityData.groupName : "N/A" }}
                    </div>
                    <div class="survey_heading">
                      Approximate time to complete
                    </div>
                    <div class="survey_content mb-17">
                      {{ activityData.timeToComplete ? (activityData.timeToComplete > 1 ? activityData.timeToComplete + " mins" : activityData.timeToComplete + " min") : "N/A" }}
                    </div>
                  </div>
                  <div class="survey_details_section_activity_setting offset-md-1 col-md-4 p-20">
                    <div class="col-lg-10 fw-500 fs-16 p-0 pb-10 color_959fa4">
                      Activity Settings
                    </div>
                    <div class="fs-14 mt-15">
                      <div class="row pb-10" v-if="activityConfig.can_score_responses == 'D'">
                        <div class="survey_content col-lg-10 p-0">
                          Ability to score responses
                        </div>
                        <div class="survey_heading col-lg-2 p-0" v-if="activityData.canScoreResponses == true">
                          Enabled
                        </div>
                        <div class="survey_heading col-lg-2 p-0 color_b8c7ce" v-else>
                          Disabled
                        </div>
                      </div>
                      <div class="row pb-10" v-if="activityConfig.allow_data_edit_checks == 'D'">
                        <div class="survey_content col-lg-10 p-0">
                          Allow site users to edit responses
                        </div>
                        <div class="survey_heading col-lg-2 p-0" v-if="activityData.allowDataEditChecks == true">
                          Enabled
                        </div>
                        <div class="survey_heading col-lg-2 p-0 color_b8c7ce" v-else>
                          Disabled
                        </div>
                      </div>
                      <div class="row pb-10" v-if="activityConfig.is_watch_enabled == 'D'">
                        <div class="survey_content col-lg-10 p-0">
                          Available for Apple Watch app
                        </div>
                        <div class="survey_heading col-lg-2 p-0" v-if="activityData.watchEnabled == true">
                          Enabled
                        </div>
                        <div class="survey_heading col-lg-2 p-0 color_b8c7ce" v-else>
                          Disabled
                        </div>
                      </div>
                      <div class="row pb-10" v-if="activityConfig.custom_participant_messaging == 'D' || activityConfig.custom_participant_messaging == undefined">
                        <div class="survey_content col-lg-10 p-0">
                          Custom Participant Message
                        </div>
                        <div class="survey_heading col-lg-2 p-0" v-if="activityData.customParticipantMessaging == true">
                          Enabled
                        </div>
                        <div class="survey_heading col-lg-2 p-0 color_b8c7ce" v-else>
                          Disabled
                        </div>
                      </div>
                      <div class="row pb-10" v-if="activityConfig.showNumericLabels == 'O' || activityConfig.showNumericLabels == 'D'">
                        <div class="survey_content col-lg-10 p-0">
                          Hide Step Numbers
                        </div>
                        <div class="survey_heading col-lg-2 p-0" v-if="activityData.hideNumericLabels == true">
                          Enabled
                        </div>
                        <div class="survey_heading col-lg-2 p-0 color_b8c7ce" v-else>
                          Disabled
                        </div>
                      </div>
                      <div class="row pb-10">
                        <div class="survey_content col-lg-10 p-0">
                          Allow participant to save progress
                        </div>
                        <div class="survey_heading col-lg-2 p-0" v-if="activityData.allowSaveProgress == true">
                          Enabled
                        </div>
                        <div class="survey_heading col-lg-2 p-0 color_b8c7ce" v-else>
                          Disabled
                        </div>
                      </div>
                      <div class="row pb-10" v-if="activityData.hasOwnProperty('enableProgressIndicator')">
                        <div class="survey_content col-lg-10 p-0">
                          Enable progress indicators
                        </div>
                        <div class="survey_heading col-lg-2 p-0" v-if="activityData.enableProgressIndicator == true">
                          Enabled
                        </div>
                        <div class="survey_heading col-lg-2 p-0 color_b8c7ce" v-else>
                          Disabled
                        </div>
                      </div>
                      <div class="row pb-10">
                        <div class="survey_content col-lg-10 p-0">
                          Define devices for completion
                        </div>
                        <div class="survey_heading col-lg-2 p-0" v-if="activityData.allowDevicesForCompletion == true">
                          Enabled
                        </div>
                        <div class="survey_heading col-lg-2 p-0 color_b8c7ce" v-else>
                          Disabled
                        </div>
                      </div>
                      <div class="row pb-10">
                        <div class="survey_content col-lg-10 p-0">
                          Allow previous responses to be shown
                        </div>
                        <div class="survey_heading col-lg-2 p-0" v-if="activityData.allowPreviousResponses == true">
                          Enabled
                        </div>
                        <div class="survey_heading col-lg-2 p-0 color_b8c7ce" v-else>
                          Disabled
                        </div>
                      </div>
                      <div class="row pb-10">
                        <div class="survey_content col-lg-10 p-0">
                          Enable data checks for responses
                        </div>
                        <div class="survey_heading col-lg-2 p-0" v-if="activityData.dataChecksForResponses == true">
                          Enabled
                        </div>
                        <div class="survey_heading col-lg-2 p-0 color_b8c7ce" v-else>
                          Disabled
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="survey_details_section pt-30">
                <div class="row pb-10 pt-10">
                  <div class="col-lg-10 fw-500 fs-16 p-0 color_4c8ce4">{{ questionAnswersLength }} Steps</div>
                  <div class="text-right color_grey">
                    <div v-if="studyId">
                      <button v-if="this.$route.name == 'data-capture-form-activity-review'" class="btn btn-default color_blue br-2 edit_button" v-on:click="changeRoute('data-capture-form-activity-questions')">
                        Edit
                      </button>
                      <button v-else class="btn btn-default color_blue br-2 edit_button" v-on:click="changeRoute('study-activities-activity-questions')">
                        Edit
                      </button>
                    </div>
                    <button v-else class="btn btn-default color_blue br-2 edit_button" v-on:click="changeRoute('activity-questions')">
                      Edit
                    </button>
                  </div>
                </div>
                <reviewQuestions class :questions="questionAnswers"></reviewQuestions>
              </div>
              <div class="activity_versions_section pt-30">
                <div class="row pb-10 pt-10">
                  <div class="col-lg-10 fw-500 fs-16 p-0 color_4c8ce4">
                    Versions
                  </div>
                </div>
                <table class="table">
                  <thead>
                    <tr>
                      <th class="border-top-0" scope="col">Name</th>
                      <th class="border-top-0" scope="col">Comments</th>
                      <th class="border-top-0" scope="col">Version Date</th>
                      <th class="border-top-0" scope="col">Modified By</th>
                      <th class="border-top-0" scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(revision, index) in activityRevisions" :key="index" :class="revision.status == 'Published' ? 'table-secondary' : ''">
                      <th scope="row">{{ revision.name }}</th>
                      <td>{{ revision.comment }}</td>
                      <td>{{ revision.modifiedTime | formatDate }}</td>
                      <td>{{ revision.modifiedBy }}</td>
                      <td class="">
                        <span v-if="revision.status == 'Published'" class="badge badge-light">Live</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="row mt-35" v-if="activityData && activityData.status == 'Draft'">
                  <label>Version Comments</label>
                  <div class="col-md-12 p-0">
                    <textarea class="form-control input-version-comment" rows="4" cols="126" v-model="comment" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row p-30" v-if="studyId">
            <div class="float-right mb-18 ml-20">
              <button type="button" class="btn-primary continue-btn" v-on:click="addActivityToStudy()">
                <span class="continue-btn-text">Continue</span>
              </button>
            </div>
          </div>
          <div class="row p-30" v-else-if="activityData && activityData.status == 'Draft'">
            <div class="float-right mb-18 ml-20">
              <button type="button" class="btn-primary continue-btn" v-on:click="saveToLibrary()">
                <span class="continue-btn-text">Save to library</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import reviewQuestions from "@/components/activity-library/activity-review-questions";
import studyActivityCommon from "@/components/configurator/study-activities-mixin";
import toastr from "toastr";
import swal from "sweetalert2";
import filter from "lodash/filter";
import QlVideoUploadService from "@/services/ql-video-upload";
import localStorage from "@/services/localStorage";

const MODULE_NAME = "activity";
export default {
  name: "activitydetails",
  data() {
    return {
      isPublished: false,
      id: null,
      taskId: null,
      activityId: null,
      revisionId: null,
      studyId: null,
      activityData: {},
      activityRevisions: null,
      sequence: 1,
      questionAnswers: [],
      questionAnswersLength: "",
      selectedQuestion: { value: "Default", label: "- Select -" },
      questions: [],
      therapeuticAreas: [],
      comment: "",
      languages: "",
      activityMode: "",
      activityTypes: [],
      activityConfig: {}
    };
  },
  mixins: [studyActivityCommon],
  components: { reviewQuestions },
  mounted() {
    this.qlVideoUpload = new QlVideoUploadService(MODULE_NAME, this.$route.params.studyId, localStorage.getItem("clientId"));
    this.activityId = this.$route.params.activityId;
    this.taskId = this.$route.params.taskId;
    this.revisionId = this.$route.params.revisionId ? this.$route.params.revisionId : this.$route.query.revisionId;
    this.studyId = this.$route.params.studyId;
    this.activityMode = this.$route.params.mode ? this.$route.params.mode : this.$route.query.mode;
    this.getTherapeuticAreas();
    this.getActivityTypes();
  },
  filters: {
    formatDate(value) {
      return moment(value).format("DD MMM YYYY hh:mm A z");
    }
  },
  methods: {
    getActivityFormConfig(typeId) {
      this.$api.getActivityFormConfig().then(response => {
        const data = response.data.result;
        this.activityConfig = data[typeId]
      });
    },
    getActivityTypes() {
      this.$api
        .getActivityTypes()
        .then(response => {
          this.activityTypes = response.data.result;
        })
        .catch(() => {
          this.$toastr.error("Error in getting Therapeutic Areas");
        });
    },
    getActivityVersions(activityId) {
      this.$api.getActivityVersions(activityId).then(
        response => {
          this.activityRevisions = response.data.result.rows;
        },
        () => {
          toastr.error("Error while getting activity versions");
        }
      );
    },
    getTherapeuticAreas() {
      this.$api
        .getTherapeuticAreas()
        .then(response => {
          this.therapeuticAreas = response.data.result;
          this.getActivityDetails();
        })
        .catch(() => {
          this.$toastr.error("Error in getting Therapeutic Areas");
        });
    },
    saveToStudy(activity) {
      const saveForm = {};
      saveForm.name = activity.name;
      saveForm.label = activity.abbreviation;
      saveForm.s3Key = activity.s3object_key;
      const questions = filter(activity.questionAnswer, question => question.type != "Section" && question.type != "SurveyCompletion");
      saveForm.noOfQuestions = questions.length;
      saveForm.fields = null;
      saveForm.studyId = this.studyId;
      saveForm.unscheduledPacketIds = [];
      saveForm.activityId = activity.activityId;
      saveForm.revisionId = activity.id;
      this.activityTypes.filter(activityType => {
        if (activityType.id === activity.typeId) {
          saveForm.type = activityType.type;
        }
      });
      this.$api.postActivityFormToStudyV3(this.studyId, saveForm).then(
        () => {
          this.$api
            .updateActivityStudyCount(activity.activityId, activity.id, {
              studyId: this.studyId
            })
            .then(
              () => {
                toastr.success("Activity added successfully to Study");
                this.$router.push({
                  name: this.$route.name == "data-capture-form-activity-review" ? "forms-list" : "study-activities",
                  params: { studyId: this.studyId }
                });
              },
              error => {
                toastr.error(error.body && error.body.message ? error.body.message : "Error while adding Activity to Study");
              }
            );
        },
        error => {
          toastr.error(error.body && error.body.message ? error.body.message : "Error while adding Activity to Study");
          this.$router.push({
            name: this.$route.name == "data-capture-form-activity-review" ? "forms-list" : "study-activities",
            params: { studyId: this.studyId }
          });
        }
      );
    },
    addActivityToStudy() {
      const isSiteFacing = this.determineActivity(this.activityData);
      this.studyId = this.studyId ? this.studyId : null;
      this.$api
        .updateActivityStatus(this.activityId, undefined, "ADDTOSTUDY", {
          comment: this.comment,
          studyId: this.studyId
        })
        .then(() => {
          if (isSiteFacing == false) {
            this.attachActivityToStudyConfigurator(this.activityData);
          } else {
            this.saveToStudy(this.activityData);
          }
        })
        .catch(error => {
          this.errorMsg = error.body ? error.body.message : "Error while adding activity to study";
        });
    },

    attachActivityToStudyConfigurator(activity) {
      if (activity) {
        const saveForm = {};

        saveForm.label = activity.abbreviation;
        saveForm.s3Key = activity.s3object_key;

        saveForm.fields = null;
        saveForm.studyId = this.studyId;
        saveForm.unscheduledPacketIds = [];
        saveForm.activityId = activity.activityId;
        saveForm.revisionId = activity.id;
        saveForm.type = activity.type;
        saveForm.title = activity.name;
        saveForm.therapeuticArea = activity.therapeuticArea;
        saveForm.therapeuticIndication = activity.therapeuticIndication;
        saveForm.timeToComplete = activity.timeToComplete ? activity.timeToComplete : 0;
        saveForm.noOfQuestions = activity.stepsCount;
        saveForm.taskId = this.taskId;
        this.$api.postNewActivityIntoStudy(this.studyId, saveForm).then(
          () => {
            this.$api
              .updateActivityStudyCount(activity.activityId, activity.id, {
                studyId: this.studyId
              })
              .then(
                () => {
                  toastr.success("Activity added successfully to Study");
                  this.$router.push({
                    name: this.$route.name == "data-capture-form-activity-review" ? "forms-list" : "study-activities",
                    params: { studyId: this.studyId }
                  });
                },
                error => {
                  toastr.error(error.body && error.body.message ? error.body.message : "Error while adding Activity to Study");
                }
              );
          },
          error => {
            toastr.error(error.body && error.body.message ? error.body.message : "Error while adding Activity to Study");
            this.$router.push({
              name: this.$route.name == "data-capture-form-activity-review" ? "forms-list" : "study-activities",
              params: { studyId: this.studyId }
            });
          }
        );
      }
    },

    saveToLibrary() {
      this.$api
        .updateActivityStatus(this.activityId, undefined, "Active", {
          comment: this.comment
        })
        .then(() => {
          this.$router.push({
            name: "activity-library-homepage"
          });
        })
        .catch(error => {
          this.errorMsg = error.body ? error.body.message : "Error while Published activity";
        });
    },
    changeRoute(route) {
      if (this.studyId) {
        this.$router.push({
          name: route,
          params: {
            activityId: this.activityId,
            studyId: this.studyId,
            mode: this.activityMode
          },
          query: { revisionId: this.revisionId, mode: this.activityMode }
        });
      } else {
        this.$router.push({
          name: route,
          params: { activityId: this.activityId, mode: this.activityMode },
          query: { revisionId: this.revisionId, mode: this.activityMode }
        });
      }
    },
    getActivityDetails() {
      this.$api.getActivityDetails(this.activityId, this.revisionId).then(
        response => {
          this.activityData = response.data.result;
          this.getActivityFormConfig(this.activityData.typeId)
          this.activityData.questions = this.qlVideoUpload.removeHarmfulScriptfromMultipleScreens(this.activityData.questions, "information");
          this.activityData.questions = this.qlVideoUpload.removeHarmfulScriptfromMultipleScreens(this.activityData.questions, "formattedInformation");
          if (this.activityData.language) {
            this.activityData.language.forEach(language => {
              this.languages += language.display_name + ", ";
            });
            this.languages = this.languages.slice(0, -2);
          }
          this.getActivityVersions(this.activityData.activityId);
          this.$store.dispatch("setActivityDetailsAction", response.data.result);
          if (this.activityData.questions && this.activityData.questions.length > 0) {
            this.questionAnswers = this.processQuestion(this.activityData.questions);
            let cnt = 0;
            for (let i = 0; i < this.questionAnswers.length; i++) {
              if (this.questionAnswers[i].type != "Section") {
                cnt++;
              }
            }
            for (let i = 0; i < this.therapeuticAreas.length; i++) {
              if (this.therapeuticAreas[i].id === this.activityData.therapeuticAreaId) {
                this.activityData.therapeuticArea = this.therapeuticAreas[i].name;
              }
            }

            this.questionAnswersLength = cnt - 1;
            this.$store.dispatch("activityQuestionsAction", this.questionAnswers);
            this.questions = this.activityData.questions;
          }
        },
        error => {
          this.errorMsg = error.body ? error.body.message : "Error while getting activity details";
          toastr.error(this.errorMsg);
        }
      );
    },
    processQuestion(question) {
      question.map(value => {
        if (value.type == "SurveyInstruction") {
          if (value.formattedTitle == "") {
            value.formattedTitle = value.title;
          }
          if (value.formattedInformation == "") {
            value.formattedInformation = value.information;
          }
        } else if (value.type == "CustomScale" && value.formattedLabels == undefined) {
          value.formattedLabels = value.labels;
        } else {
          if (value.formattedBody == "") {
            value.formattedBody = value.body;
          }
          if (value.options !== undefined && value.options.formattedBody == "") {
            value.options.formattedBody = value.options.body;
          }
        }
      });
      return question;
    },
    markAsPublished(revision) {
      swal({
        title: "Are you sure you would like to push this version live? This will replace the current version of this activity in the library?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#f16559",
        confirmButtonText: "Cancel",
        cancelButtonText: "Continue"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.$api
            .updateActivityStatus(revision.activityId, revision.revisionId, "Published")
            .then(() => {
              toastr.success("Activity version is live");
              this.$refs.activityVersionsModal.hide();
              this.$emit("refreshActivityList", {});
            })
            .catch(error => {
              this.errorMsg = error.body ? error.body.message : "Error while Published activity";
            });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
// Style for quick fixes bootstrap after migration (before redesign should be removed)
.tags-page {
  font-family: "RobotoRegular";

  &__back-to-activites {
    color: #4c8ce4;
  }

  .container {
    max-width: 90%;
  }

  &__header {
    margin: 100px auto 0 auto;

    &__add-tag-btn {
      width: 116px;
      height: 35px;
      border-radius: 4px;
      background-color: #4c8ce4;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      color: #ffffff;
    }
  }

  .manage-tags-text {
    /* width: 105px; */
    height: 24px;
    font-family: "RobotoRegular";
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    color: #000000;
  }

  .manage-tags-description {
    font-family: "RobotoRegular";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.71;
    letter-spacing: normal;
    color: #000000;
  }

  .add-tag-modal {
    .modal-dialog {
      vertical-align: top !important;
      top: 100px;
    }

    &__container {
      width: 902px;
      height: 219px;
      border-radius: 4px;
      background-color: #ffffff;

      .fw-bold {
        font-weight: bold;
      }

      .color-black {
        color: black;
      }
    }

    &__name-input {
      width: 220px;
      height: 35px;
      border-radius: 3px;
      border: solid 1px #d3dfe4;
    }

    &__desc-input {
      width: 549px;
      height: 35px;
      border-radius: 3px;
      border: solid 1px #d3dfe4;
    }

    &__add-another-tag {
      font-family: "RobotoRegular";
      font-size: 12px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.67;
      letter-spacing: normal;
      color: #4c8ce4;
      cursor: pointer;
    }

    &__save-tag-btn {
      width: 102px;
      height: 35px;
      border-radius: 4px;
      background-color: #4c8ce4;
      color: white;
    }
  }
}
body {
  color: #333;
}

.h2,
h2 {
  font-size: 30px;
  margin: 20px 0 10px;
}

.h3,
h3 {
  font-size: 24px;
  color: #333;
}

.h5,
h5 {
  font-size: 14px;
  margin: 10px 0;
}

.h6,
h6 {
  font-size: 12px;
  margin: 10px 0;
  color: #333;
}

.btn {
  font-size: 14px;
}

.col-xs-12 {
  width: 100%;
}

.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  float: left;
  //flex: none;
  display: block;
}

.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}

.col-xs-10 {
  width: 83.33333333%;
}

.panel-default {
  border-color: #ddd;
}

.panel {
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.row {
  display: block;

  &:after {
    content: "";
    clear: both;
    display: block;
  }
}

.color_959fa4 {
  color: #959fa4 !important;
}

.scheduler {
  border-bottom: 2px solid #d3dfe4;
  padding-bottom: 30px;
}

@media (min-width: 768px) {
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12 {
    float: left;
    display: block;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-10 {
    width: 83.33333333%;
  }
  .col-sm-4 {
    width: 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-md-2 {
    flex: none;
  }
}

@media (min-width: 992px) {
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12 {
    float: left;
    flex: none;
  }
  .col-md-2 {
    width: 16.66666667%;
  }
  .col-md-10 {
    width: 83.33333333%;
  }
  .col-md-12 {
    width: 100%;
  }
}

@media (min-width: 1200px) {
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12 {
    float: left;
    display: block;
  }
  .col-lg-2 {
    width: 16.66666667%;
  }
  .col-lg-10 {
    width: 82.33333333%;
  }
  .col-lg-11 {
    width: 91.66666667%;
  }
}

// END of style for quick fixes bootstrap after migration (before redesign should be removed)

h1,
h2,
h3 {
  font-weight: 200;
}
.form-control {
  border-radius: 2px;
}
.pr-0 {
  padding-right: 0;
}

.pl-0 {
  padding-left: 0;
}

.img-style {
  padding-top: 20px;
  height: 300px;
  width: 500px;
  padding-bottom: 20px;
}

.font-style {
  color: #57dd7a;
  font-size: 16px;
  padding-top: 10px;
  padding-bottom: 30px;
}

.text-style {
  color: #969090;
  text-align: right;
}

.btn-style {
  margin-top: 10px;
  width: 80px;
  height: 29px;
  margin-bottom: 50px;
}

.custom-btn {
  background: #00baf9;
  color: #fff;
  width: 220px;
}

.custom-para {
  padding-bottom: 20px;
  font-size: 20px;
}

.mar-bot20 {
  margin-bottom: 20px;
}

.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}

.btn-disabled {
  color: white;
  background-color: #c6c2c2;
  border: #c6c2c2;
}

.text-color {
  color: #888;
}

.read_only_card {
  background-color: #f5f8fa;
  border: 1px solid #d3dfe4;
  border-left: 8px solid #d3dfe4;
  padding: 15px;
  margin-bottom: 16px;
  .instuction_title {
    font-size: 18px;
    font-weight: bold;
  }
}

.survey-name {
  color: #00baf9;
  font-size: 20px;
}

.pad-left50 {
  padding-left: 50px;
}

.button-blue-1 {
  background: #00bae0;
  color: #fff;
}

.button-blue-2 {
  background-color: #0197eb;
  color: #fff;
}

.mar-bot20 {
  margin-bottom: 20px;
}

.mar-bot0 {
  margin-bottom: 0px !important;
}

.first_question_selection {
  img {
    width: 100%;
    max-width: 100px;
  }
  .header {
    font-size: 24px;
    font-weight: 200;
    padding: 14px;
  }
  .label_text {
    font-size: 18px;
    padding-bottom: 10px;
    font-weight: 400;
  }
  select {
    margin: auto;
    width: 100%;
    max-width: 300px;
  }
}
.question_count {
  background-color: #34537d;
  color: #fff;
  width: 25px;
  display: inline-block;
  border-radius: 10px;
  text-align: center;
}
.inner-card {
  border: 1px solid #ddd;
  box-shadow: 1px 0px 1px 1px #ddd;
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f6fafc;
}

.select-style {
  background: #f9f9f9;
  border-radius: 2px;
}

.radio-style {
  margin-top: 5px !important;
  font-size: 14px;
  color: #555555;
}
.btn_add {
  border-radius: 25px;
  border: solid 1px #f16559;
  color: #f16559;
  background-color: transparent;
}
.check-style {
  margin-top: 5px !important;
  font-size: 14px;
  color: #555555;
  padding: 0px 20px;
}

.border-left {
  border-left: 1px solid #555555;
}
.container-style {
  border-radius: 2px;
  background-color: #ffffff;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
}

.input-style {
  width: 45px;
  margin-left: 10px;
  background: #f9f9f9;
  display: initial;
  padding: 5px;
}

.char-style {
  font-size: 14px;
  color: #555555;
}

.card {
  padding: 15px;
  color: #666769 !important;
}

.add_another_btn {
  font-size: 14px;
  background-color: transparent;
  border-color: #f06559;
  color: #f06559;
  margin-bottom: 20px;
}

.preview-btn {
  background-color: #d4f2ff;
  width: 100%;
  // max-width: 150px;
  padding: 10px 0;
}

.icon-style {
  font-size: 47px;
  position: absolute;
  left: 30px;
  /* bottom: 0px; */
  top: -25px;
}

.pl-25 {
  padding-left: 25px;
}

@media (max-width: 575px) {
  .container-padding {
    padding-left: 20px;
  }
}

@media (min-width: 576px) and (max-width: 767px) {
}

@media (min-width: 768px) and (max-width: 991px) {
}

@media (min-width: 992px) and (max-width: 1199px) {
}

@media (min-width: 1200px) {
}

.survey_details_section {
  border-bottom: 2px solid #d3dfe4;
  padding-bottom: 30px;
}

.edit_button {
  background-color: #ffffff;
  border: 1px solid #d3dfe4;
  font-size: 12px;
}

.survey_heading {
  color: #959fa4;
  font-size: 12px;
  font-weight: bold;
}

.survey_content {
  color: #666669;
  font-size: 14px;
}

.back_link {
  color: #666669;
}

.reminder_heading {
  color: #666669;
}

.checkbox_position {
  position: relative;
  top: 2px;
}

ul {
  margin: 0;
  padding: 0 0 0 15px;
}
.continue-btn {
  width: 122px;
  height: 36px;
  cursor: pointer;
  background-color: #4c8ce4;
  border-radius: 100px;
  border: solid 2px #4c8ce4;
  outline: none;
}
.continue-btn-text {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #ffffff;
}
.cancel-btn {
  width: 122px;
  height: 36px;
  background-color: #ffffff !important;
  border-radius: 100px;
  border: solid 2px #ffffff !important;
  cursor: pointer;
  outline: none;
}
.cancel-btn-text {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #4c8ce4;
}
.warning-message {
  height: 15px;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #f0ad4e;
}
.activity_versions_section .table th,
.activity_versions_section .table td {
  padding: 5.2px 0.75rem;
}
.activity_versions_section .table tbody {
  border: 1px solid #dee2e6;
  -webkit-box-shadow: 0.5px 0.5px 2px 1px rgba(176, 186, 201, 1);
  -moz-box-shadow: 0.5px 0.5px 2px 1px rgba(176, 186, 201, 1);
  box-shadow: 0.5px 0.5px 2px 1px rgba(176, 186, 201, 1);
}
.activity_versions_section .table th {
  color: #b0bac9;
}
.activity_versions_section label {
  color: #666669;
}
.input-version-comment {
  width: 100%;
  height: 80px;
  border: 1px solid #ccc;
  background: #f7f7f7;
}
.activity_versions_section .table tbody tr td:last-child {
  width: 8%;
}
.activity_versions_section .table tr td:nth-child(4) {
  width: 10%;
}
.activity_versions_section .table tr td:nth-child(3) {
  width: 15%;
}
.activity_versions_section .table tr td:nth-child(2) {
  width: 35%;
}
.activity_versions_section .table tr th:first-child {
  width: 20%;
}
.survey_details_section_activity_setting {
  border-radius: 4px;
  border: solid 1px #d3dfe4;
  background-color: #f5f8fa;
}
.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: #d3dfe4;
}
.author_info_box {
  position: relative;
  left: 5%;
}
.badge-light {
  color: #fff;
  width: 36px;
  height: 20px;
  padding: 3px 7px;
  border-radius: 4px;
  background-color: rgba(176, 186, 201, 0.8);
  font-size: 12px;
  font-weight: 500;
}
.therapeutic {
  line-break: anywhere;
}
</style>
